"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[174],{

/***/ 51297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AU": function() { return /* binding */ nextjsOverview; },
/* harmony export */   "DV": function() { return /* binding */ integrationSuggestions; },
/* harmony export */   "Dk": function() { return /* binding */ componentReference; },
/* harmony export */   "jz": function() { return /* binding */ frontendSuggestions; },
/* harmony export */   "rI": function() { return /* binding */ backendSuggestions; },
/* harmony export */   "s7": function() { return /* binding */ conceptsSuggestions; },
/* harmony export */   "vi": function() { return /* binding */ generalSuggestions; },
/* harmony export */   "wZ": function() { return /* binding */ featureSuggestions; }
/* harmony export */ });
/* unused harmony exports frontendSDKs, backendSDKs */
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96618);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59910);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27523);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81516);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98431);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60364);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59501);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51304);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(43204);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(18302);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(99007);

const generalSuggestions = [
    {
        title: "Quickstarts & Tutorials",
        description: "Explore our end-to-end tutorials and getting started guides for different application stacks using Clerk. ",
        url: "/docs/quickstarts/overview",
        icon: _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z
    },
    {
        title: "UI Components",
        description: "Clerk's pre-built UI components give you a beautiful, fully-functional user\n    management experience in minutes.",
        url: "/docs/component-reference/overview",
        icon: _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z
    },
    {
        title: "API Reference",
        description: "Dig into our API reference documentation and SDKs. We have everything you need to get started setting up authentication with Clerk.",
        url: "/docs/reference/overview",
        icon: _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z
    },
    {
        title: "Security",
        description: "Account security is the top concern of every feature we build. This documentation lists some of the many protections included with Clerk.",
        url: "/docs/security/introduction",
        icon: _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z
    }
];
const frontendSuggestions = (isLightMode)=>[
        {
            title: "Next.js",
            description: "Easily add secure, beautiful, and fast authentication to Next.js with Clerk.",
            url: "/docs/nextjs/get-started-with-nextjs",
            logo: isLightMode ? "/images/logos/nextjs.svg" : "/images/logos/nextjs-white.svg",
            logoWidth: 40
        },
        {
            title: "React",
            description: "Get started installing and initializing Clerk in a new Create React App.",
            url: "/docs/quickstarts/get-started-with-create-react-app",
            logo: "/images/logos/react.svg"
        },
        {
            title: "Remix",
            description: "Easily add secure, edge- and SSR-friendly authentication to Remix with Clerk.",
            url: "/docs/quickstarts/get-started-with-remix",
            logo: isLightMode ? "/images/logos/remix.svg" : "/images/logos/remix-white.svg",
            logoHeight: 22
        },
        {
            title: "Gatsby",
            description: "Learn about installing and initializing Clerk in a new Gatsby application.",
            url: "/docs/quickstarts/get-started-with-gatsby",
            logo: "/images/logos/gatsby.svg"
        },
        {
            title: "RedwoodJS",
            description: "Grow your RedwoodJS application with Clerk user management and authentication.",
            url: "/docs/quickstarts/get-started-with-redwoodjs",
            logo: "/images/logos/redwood.svg"
        },
        {
            title: "React Native / Expo",
            description: "Use Clerk with Expo to authenticate users in your React Native application. ",
            url: "/docs/quickstarts/get-started-with-expo",
            logo: isLightMode ? "/images/logos/expo.svg" : "/images/logos/expo-white.svg"
        }
    ];
const backendSuggestions = (isLightMode)=>[
        {
            title: "Node / Express",
            description: "Quickly add authentication and user management to your Node.js application.",
            url: "/docs/reference/node/getting-started",
            logo: isLightMode ? "/images/logos/node.svg" : "/images/logos/node-white.svg",
            logoWidth: 44
        },
        {
            title: "Ruby on Rails",
            description: "Integrate user management and authentication into your Ruby application.",
            url: "/docs/reference/ruby/getting-started",
            logo: "/images/logos/ruby.svg"
        },
        {
            title: "SDKs",
            description: "Clerk's SDKs allow you to call the Clerk server API without having to implement the calls yourself.",
            url: "/docs/reference/overview",
            icon: _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z
        }
    ];
const featureSuggestions = [
    {
        title: "Authentication",
        description: "Clerk supports multiple authentication strategies so you can implement the strategy that makes sense for your users.",
        url: "/docs/authentication/overview",
        icon: _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z
    },
    {
        title: "User management",
        description: "Complete user management. Add sign up, sign in, and profile management to your application in minutes.",
        url: "/docs/users/overview",
        icon: _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z
    },
    {
        title: "Database integrations",
        description: "Enable Clerk-managed users to authenticate and interact directly with your database with Clerk's integrations.",
        url: "/docs/integration/overview",
        icon: _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z
    },
    {
        title: "Customization",
        description: "Clerk's components can be customized to match the look and feel of your application.",
        url: "/docs/component-customization/appearance-prop",
        icon: _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z
    },
    {
        title: "Session management",
        description: "Speed up your application with sub-millisecond authentication, mitigate hackers with active device management and revocation, and much more.",
        url: "/docs/build-frontend-first/session-authentication",
        icon: _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z
    },
    {
        title: "Organizations",
        description: "Organizations are shared accounts, useful for project and team leaders. Members with elevated privileges can manage member access to the organization's data and resources.",
        url: "/docs/how-to/organizations",
        icon: _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z
    }
];
const conceptsSuggestions = [
    {
        title: "What is Clerk authentication?",
        description: "Clerk offers multiple authentication strategies to identify legitimate users of your appication, and to allow them to make authenticated requests to your backend.",
        url: "/docs/authentication/overview"
    },
    {
        title: 'What is the "User" object?',
        description: "The User object contains all account information that describes a user of your app in Clerk. Users can authenticate and manage their accounts, update their personal and contact info, or set up security features for their accounts.",
        url: "/docs/users/overview"
    },
    {
        title: "How do organizations work?",
        description: "Organizations allow members to collaborate across shared resources. Each member of an organization needs to have a user account in your application. All organization members have access to most of the organization resources, but some members can take advantage of administrative features.",
        url: "/docs/organizations/overview"
    }
];
const componentReference = [
    {
        title: "UI Components",
        description: "Clerk's pre-built UI components give you a beautiful, fully-functional user\n    management experience in minutes.",
        url: "/docs/component-reference/sign-in",
        icon: _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z
    },
    {
        title: "Control Components",
        description: "Clerk's control components render at <Loading /> and <Loaded /> states for assertions on the Clerk object.",
        url: "/docs/component-reference/clerk-loaded",
        icon: _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z
    },
    {
        title: "Customization",
        description: "Fully customize our UI components with your own style preferences. With support for Tailwind CSS, Chakra UI, and more.",
        url: "/docs/component-customization/appearance-prop",
        icon: _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z
    },
    {
        title: "Internationalization",
        description: "Functionality which enables UI strings to be passed into components so they can be translated in different languages.",
        url: "/docs/component-customization/localization-prop",
        icon: _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z
    }
];
const frontendSDKs = [
    {
        title: "JavaScript",
        description: "ClerkJS is our foundational JavaScript library for building user management and authentication.",
        url: "/docs/reference/clerkjs/installation",
        logo: "/images/logos/javascript.svg"
    },
    {
        title: "React",
        description: "Clerk React is the recommended way to integrate Clerk into your React application.",
        url: "/docs/reference/clerk-react/installation",
        logo: "/images/logos/react.svg"
    },
    {
        title: "React Native / Expo",
        description: "Clerk Expo is the recommended way to integrate Clerk into your React Native application.",
        url: "/docs/reference/clerk-expo",
        logo: "/images/logos/expo.svg"
    }
];
const backendSDKs = [
    {
        title: "Go",
        description: "Clerk Go SDK is a wrapper around our Backend API written in Golang.",
        url: "/docs/reference/golang/getting-started",
        logo: "/images/logos/go.svg",
        logoWidth: 40
    },
    {
        title: "Node.js",
        description: "Clerk Node SDK is the recommend way to integrate Clerk into your Node / Express application.",
        url: "/docs/reference/node/getting-started",
        logo: "/images/logos/node.svg",
        logoWidth: 40
    },
    {
        title: "Ruby",
        description: "Clerk Ruby is the recommended way to integrate Clerk into your Ruby application.",
        url: "/docs/reference/ruby/getting-started",
        logo: "/images/logos/ruby.svg"
    }
];
const integrationSuggestions = (isLightMode)=>[
        {
            title: "Firebase",
            description: "Clerk integrates directly with Firebase, a popular Platform-as-a-Service (PaaS) provider, so developers can easily add our beautiful Sign Up, Sign In, and User Profile UIs to their Firebase application.",
            url: "/docs/integration/firebase",
            logo: "/images/logos/firebase.svg"
        },
        {
            title: "Supabase",
            description: "Clerk embraces the open source alternative to Firebase and provides an integration to Supabase with our JSON Web Tokens (JWT) Templates feature.",
            url: "/docs/integration/supabase",
            logo: "/images/logos/supabase.svg"
        },
        {
            title: "Hasura",
            description: "Easily connect to your Hasura GraphQL endpoint using Clerk as your authentication provider.",
            url: "/docs/integration/hasura",
            logo: isLightMode ? "/images/logos/hasura.svg" : "/images/logos/hasura-white.svg"
        },
        {
            title: "Fauna",
            description: "Build applications using Fauna, the distributed document-relational database, with Clerk as your authentication provider.",
            url: "/docs/integration/fauna",
            logo: "/images/logos/fauna.svg"
        },
        {
            title: "Grafbase",
            description: "Build applications with serverless GraphQL backends provided by Grafbase and user authencation provided by Clerk.",
            url: "/docs/integration/grafbase",
            logo: isLightMode ? "/images/logos/grafbase.svg" : "/images/logos/grafbase-white.svg"
        },
        {
            title: "Nhost",
            description: "The open source alternative to Firebase with GraphQL seemlessly integrates with Clerk to provide authenticated queries.",
            url: "/docs/integration/nhost",
            logo: isLightMode ? "/images/logos/logomark-nhost.svg" : "/images/logos/logomark-nhost.svg"
        },
        {
            title: "Convex",
            description: "Clerk integrates with Convex, the serverless state management platform, using our JSON Web Tokens (JWT) Templates feature.",
            url: "/docs/integration/convex",
            logo: "/images/logos/convex.svg"
        },
        {
            title: "Google Analytics",
            description: "Send user authentication events to your Google Analytics property to enable metrics tracking on user sign up and sign in events.",
            url: "/docs/integration/google-analytics",
            logo: "/images/logos/logomark-google-analytics.svg"
        }
    ];
const nextjsOverview = (isLightMode)=>[
        {
            title: "Get Started",
            description: "Easily install Clerk into your Next.js application",
            url: "/docs/nextjs/get-started-with-nextjs"
        },
        {
            title: "Embeddable UIs",
            description: "Embed Clerk UI components into your Next.js application",
            url: "/docs/nextjs/signup"
        },
        {
            title: "Authenticating your application",
            description: "Access authentication with Clerk in your Next.js application",
            url: "/docs/nextjs/middleware"
        },
        {
            title: "React Helpers",
            description: "Leverage Clerk React helpers for your Next.js applicaton",
            url: "/docs/nextjs/useauth"
        },
        {
            title: "Server-side APIs",
            description: "Access Clerk data using our backend API",
            url: "/docs/nextjs/accessing-the-api"
        }
    ];


/***/ }),

/***/ 23649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ CtaCard; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8395);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52494);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63519);
/* harmony import */ var pages__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16263);






function CtaCard(param) {
    let { url , title , description , ctaText , icon , logo , logoHeight =24 , logoWidth =24 , size ="md"  } = param;
    const headingSize = size === "md" ? "2xs" : "xs";
    const descriptionSize = size === "md" ? "xs-normal" : "sm-normal";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        legacyBehavior: true,
        href: url,
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Stack */ .Kq, {
            as: "a",
            layerStyle: "linkCard",
            bg: "var(--cardBg)",
            role: "group",
            justify: "space-between",
            _hover: {
                boxShadow: (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .useColorModeValue */ .ff)("dropShadow2", "dropShadow1")
            },
            onClick: ()=>pages__WEBPACK_IMPORTED_MODULE_5__.analytics.track("Docs_Home_Card Clicked", {
                    surface: "Docs",
                    location: "Home",
                    ClickedOn: title
                }),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                    children: [
                        logo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                            mb: 4,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                src: logo,
                                alt: "".concat(title, " logo"),
                                height: logoHeight,
                                width: logoWidth
                            })
                        }),
                        icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Icon */ .JO, {
                            as: icon,
                            color: "var(--primaryBlue)",
                            boxSize: 6,
                            mb: 5
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X6, {
                            as: "h3",
                            size: headingSize,
                            mb: 2,
                            color: "var(--primaryTextColor)",
                            children: title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
                            color: "var(--secondaryTextColor)",
                            textStyle: descriptionSize,
                            maxW: "60ch",
                            mb: 5,
                            children: description
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
                    color: "var(--secondaryTextColor)",
                    textStyle: "xs-medium",
                    _groupHover: {
                        color: "var(--secondaryBlue)"
                    },
                    children: [
                        ctaText,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Icon */ .JO, {
                            as: _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z,
                            ml: 1,
                            pos: "relative",
                            top: "-1px",
                            transition: "margin-left .2s",
                            _groupHover: {
                                ml: 2
                            }
                        })
                    ]
                })
            ]
        })
    }, title);
}


/***/ }),

/***/ 66275:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ SectionHeading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52494);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51183);



function SectionHeading(param) {
    let { thinText , boldText , size ="md"  } = param;
    const headingSize = size === "md" ? "h6" : "h5";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6, {
        size: headingSize,
        color: "var(--primaryTextColor)",
        children: [
            thinText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                        as: "span",
                        fontWeight: "normal",
                        children: thinText
                    }),
                    " "
                ]
            }),
            boldText,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO, {
                as: _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
                boxSize: 5,
                color: "var(--secondaryTextColor)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO, {
                as: _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
                boxSize: 5,
                color: "var(--secondaryTextColor)",
                pos: "relative",
                left: "-14px"
            })
        ]
    });
}


/***/ }),

/***/ 19630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ Support; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52494);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2905);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63519);





const support = [
    {
        title: "Join our Discord",
        description: "Join our official Discord server to chat with us directly and become a part of the Clerk community.",
        url: "https://discord.com/invite/b5rXHjAg7A",
        ctaText: "Join Discord",
        logo: "/images/logos/discord.svg"
    },
    {
        title: "Need help?",
        description: "Contact us through Discord, Twitter, or email to receive answers to your questions and learn more about Clerk.",
        url: "/support",
        ctaText: "Get help",
        icon: _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z
    }
];
function Support() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, {
        pb: 12,
        children: support.map((param, index)=>{
            let { title , description , url , ctaText , logo , icon  } = param;
            const isFirst = index === 0;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
                pr: isFirst ? 6 : 0,
                pl: !isFirst ? 6 : 0,
                flex: 1,
                borderRight: isFirst ? "1px solid" : "none",
                borderColor: "var(--borderColor)",
                children: [
                    logo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
                        mb: 4,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: logo,
                            alt: "".concat(title, " logo"),
                            height: 24,
                            width: 24
                        })
                    }),
                    icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Icon */ .JO, {
                        as: icon,
                        color: "var(--iconColor)",
                        boxSize: 6,
                        mb: 5
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Heading */ .X6, {
                        as: "h3",
                        size: "3xs",
                        mb: 0.5,
                        color: "var(--primaryTextColor)",
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                        color: "var(--secondaryTextColor)",
                        textStyle: "xs-normal",
                        maxW: "60ch",
                        mb: 4,
                        children: description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        legacyBehavior: true,
                        href: url,
                        passHref: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                            as: "a",
                            color: "var(--secondaryTextColor)",
                            textStyle: "xs-medium",
                            role: "group",
                            _hover: {
                                color: "var(--secondaryBlue)"
                            },
                            children: [
                                ctaText,
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Icon */ .JO, {
                                    as: _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
                                    ml: 1,
                                    pos: "relative",
                                    top: "-1px",
                                    transition: "margin-left .2s",
                                    _groupHover: {
                                        ml: 2
                                    }
                                })
                            ]
                        })
                    })
                ]
            }, title);
        })
    });
}


/***/ })

}]);